import ApiServiceWrapper from './../../api-request.service';
const mainPrefix = 'promotions';
const promoPrefix =  'promotions/get-promotions';
const upgradePrefix = 'promotions/get-upgrade-details?upgradeID';
const applicablePrefix = 'promotions/get-apply-upgrade-details';
const promoSecurePrefix = 'promotions/get-promosecureupgrade-sernos';
const competPrefix = 'promotions/competative-survey-options';
const promotionsAPI = {
  getPromotions() {
    return ApiServiceWrapper.get(promoPrefix);
  },
  getUpgradeDetails(id: any) {
    return ApiServiceWrapper.get(`${upgradePrefix}=${id}`);
  },
  getApplicablePromotions() {
    return ApiServiceWrapper.get(applicablePrefix);
  },
  getPromoSecure(data: any) {
    return ApiServiceWrapper.get(`${promoSecurePrefix}?seriaNumber=${data.serNo}&upgradeId=${data.id}`);
  },
  getCompetitiveSurvey() {
    return ApiServiceWrapper.get(`${competPrefix}`);
  },
  submitCompetitiveSurvey(data: any) {
    // tslint:disable-next-line:max-line-length
    return ApiServiceWrapper.get(`${mainPrefix}/submit-competative-survey?competitiveReplacementDevice=${data.competitiveReplacementDevice}&competitiveProductInfo=${data.competitiveProductInfo}&competitiveReplacementSerialnumber=${data.competitiveReplacementSerialnumber}&strUpgradeSerial=${data.strUpgradeSerial}&strUpgradeNo=${data.strUpgradeNo}`);
  },
  // getPromoSecureUpgrade(data: any) {
  //   return ApiServiceWrapper.get(`${mainPrefix}/get-promosecureupgrade-sernos?seriaNumber=${data.serNo}&upgradeId=${data.uID}`);
  // },
  getTransferGridData(fromSrNo: any, toSrNo:any, upgradeID:any) {
    return ApiServiceWrapper.get(`${mainPrefix}/get-transfer-secure-upgrade?fromSerial=${fromSrNo}&toSerial=${toSrNo}&fromPage=promotions&upgradeID=${upgradeID}`);
  },
  completeTransfer(fromSrNo: any, toSrNo:any, upgradeID:any) {
    return ApiServiceWrapper.get(`${mainPrefix}/submit-transfer-secure-upgrade?fromSerial=${fromSrNo}&toSerial=${toSrNo}&upgradeID=${upgradeID}`);
  },
};

export default promotionsAPI;
